import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/skinfill/Footer";

const Para = ({ children }) => (
  <p className="text-[15px] font-light text-[#4a4144] leading-relaxed max-w-3xl">{children}</p>
);

const Disclaimer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="disclaimer-page" className="bg-[#FAF7F5] min-h-screen">
      <header className="sticky top-0 z-50 bg-[#FAF7F5]/85 backdrop-blur-xl border-b border-[#EADECE]/60">
        <div className="max-w-5xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="disclaimer-logo-link" className="font-serif text-lg tracking-[0.08em] text-[#1C1417]">
            SKINFILL <span className="italic text-[#D84A75]">BACIO</span>
            <sup className="text-[9px] ml-0.5">®</sup>
          </Link>
          <Link
            to="/"
            data-testid="disclaimer-back-link"
            className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#A31D4F] hover:text-[#86143E] transition-colors"
          >
            <ArrowLeft size={14} />
            Back to site
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <p className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.28em] text-[#A31D4F]">Legal</p>
        <h1 className="font-serif font-light text-[#1C1417] text-4xl sm:text-6xl tracking-tight mt-5 leading-[1.02]">
          Dis<span className="italic text-[#A31D4F]">claimer</span>
        </h1>

        <div className="mt-14 space-y-6">
          <Para>
            The information presented on this website relates to Skinfill Bacio® and is provided for general product,
            beauty and cosmetic information purposes.
          </Para>
          <Para>
            Skinfill Bacio® is presented on this website as a product intended to support the appearance, hydration,
            smoothness and overall cosmetic condition of the lips.
          </Para>
          <Para>
            References to terms such as &ldquo;Lip Booster,&rdquo; &ldquo;hydration,&rdquo; &ldquo;revitalised
            appearance,&rdquo; &ldquo;smoother-looking lips,&rdquo; &ldquo;lip quality,&rdquo;
            &ldquo;freshness&rdquo; and similar expressions are cosmetic and descriptive marketing terms. They are
            intended to describe the appearance and cosmetic positioning of the product and should not be interpreted
            as claims to diagnose, treat, cure or prevent any disease or medical condition.
          </Para>
          <Para>
            The term &ldquo;Lip Booster&rdquo; is a marketing description and does not represent a medical or
            regulatory classification.
          </Para>
          <Para>
            This website does not provide medical advice and should not be relied upon for diagnosis, treatment or
            management of any medical condition.
          </Para>
          <Para>
            Product suitability, permitted use and professional requirements may vary according to the applicable
            laws, regulations and professional standards in Australia and New Zealand.
          </Para>
          <div>
            <Para>
              Any professional using or supplying Skinfill Bacio® is responsible for ensuring that its use is
              consistent with:
            </Para>
            <ul className="list-disc pl-5 space-y-1.5 marker:text-[#D84A75] mt-3 text-[15px] font-light text-[#4a4144] leading-relaxed max-w-3xl">
              <li>the manufacturer's current product information and instructions;</li>
              <li>applicable Australian or New Zealand legislation and regulatory requirements;</li>
              <li>relevant professional standards and scope-of-practice requirements; and</li>
              <li>any other requirements applicable to the manner in which the product is supplied or used.</li>
            </ul>
          </div>
          <Para>
            Images, videos and before-and-after content are provided for illustrative purposes. Individual cosmetic
            appearance and results may vary.
          </Para>
          <Para>
            No statement on this website should be interpreted as a guarantee of a particular cosmetic outcome.
          </Para>
          <Para>
            Nothing on this website is intended to alter, determine or replace the regulatory status or classification
            of Skinfill Bacio® under applicable Australian or New Zealand law.
          </Para>

          <div className="pt-10 mt-10 border-t border-[#EADECE]">
            <p className="font-serif text-2xl text-[#1C1417]">
              SKINFILL <span className="italic text-[#D84A75]">BACIO</span>
              <sup className="text-xs">®</sup>
            </p>
            <p className="mt-3 text-[15px] font-light text-[#4a4144]">
              Australia &amp; New Zealand Distributor:{" "}
              <span className="font-mono text-sm tracking-[0.2em] uppercase">Dermalis</span>
            </p>
            <a
              href="mailto:info@dermalis.com.au"
              className="inline-block mt-2 text-[15px] text-[#A31D4F] hover:text-[#86143E] underline underline-offset-4 decoration-[#E893AE]/60"
            >
              info@dermalis.com.au
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Disclaimer;
